
<template>
    <div>
        <nav id="sidebar" :class="{ active: value }">
            <div  class="left_sidebar float-left">
                <div class="left_sidebar_profile" :style="$store.getters.getUserInfo.userAvatar && 'background-image: linear-gradient(rgba(69,35,121,0) 220px, rgba(69,35,121,1)), url('+$store.getters.getUserInfo.userAvatar+');'"></div>
                <h3 class="user_name">{{$store.getters.getUserInfo.userName}}</h3>
                <div class="user_category" v-if="$store.getters.getUserInfo.userGeneralExperience">Общий стаж: {{ $store.getters.getUserInfo.userGeneralExperience }}</div>
                <div class="user_category" v-if="$store.getters.getUserInfo.userProfessionalExperience">Проф. стаж: {{ $store.getters.getUserInfo.userProfessionalExperience }}</div>
                
                <!-- <div class="sidebar_info">
                    <div class="sidebar_title">Краткая информация</div>
                    <ul>
                    <li>Учитель георграфии</li>
                    <li>Общий стаж: 15 лет</li>
                    <li>Проф. стаж: 10 лет</li>
                    </ul>
                </div> -->
                <v-list class="nav-menu" dark color="transparent">
                    <v-list-item-group>
                        <v-list-item
                          v-for="(item, i) in items"
                          :key="i"
                          :to="item.route"
                        >
                            <v-list-item-icon>
                                <v-icon v-text="item.icon"></v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title v-text="item.text"></v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
                <!--<div class="sidebar_info">
                <div class="sidebar_title">Краткая информация</div>
                <ul>
                  <li>17.08.1996</li>
                  <li>Учитель георграфии</li>
                  <li>Общий стаж: 15 лет</li>
                  <li>Проф. стаж: 10 лет</li>
                </ul>

                <div class="sidebar_title">Контакты</div>
                <ul>
                  <li>+7 778 228 40 32</li>
                  <li>kuanish@mail.kz</li>
                  <li>@linkedin.com</li>
                  <li>@instagram.com</li>
                </ul>

                <div class="sidebar_title">Навыки</div>
                <ul>
                  <li>Internet, CCNA, PHP, Javascript, Office, HTM, 1С-пользователь, 1С-программист, Python</li>
                </ul>
                </div>-->
            </div>
        </nav>
    </div>
</template>





<script>
  export default {
    props: ['value'],
    data () {
      return {
        open: false,
        showMobileMenu: false,
        items: [
            { text: 'Персональные данные', icon: 'mdi-card-account-mail', route: '/' },
            { text: 'Образование ', icon: 'mdi-school', route: '/education' },
            { text: 'Квалификация', icon: 'mdi-wallet-membership', route: '/training-category' },
            { text: 'Курсы повышения', icon: 'mdi-wallet-membership', route: '/training' },
            { text: 'Достижения и награды', icon: 'mdi-star', route: '/achievement' },
            { text: 'Стаж работы', icon: 'mdi-briefcase', route: '/experience' },
            { text: 'Знание языков', icon: 'mdi-translate', route: '/language-knowledge' },
        ],
      }
    },
  }
</script>



<style>
    .nav-menu .v-list-item__icon {
        margin-right: 30px;
    }

    .nav-menu a:hover {
        text-decoration: none;
    }

    .navbar {
        padding: 5px 5px;
        background: #fff;
        border: none;
        border-radius: 0;
        margin-bottom: 40px;
        box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);
    }

    .navbar-btn {
        box-shadow: none;
        outline: none !important;
        border: none;
    }

    .line {
        width: 100%;
        height: 1px;
        border-bottom: 1px dashed #ddd;
        margin: 40px 0;
    }


    .wrapper {
        display: flex;
        width: 100%;
        align-items: stretch;
    }

    #sidebar {
        min-width: 300px;
        max-width: 3000px;
        height: 100%;
        background: #7386D5;
        color: #fff;
        transition: all 0.3s;
    }

    #sidebar.active {
        margin-left: -300px;
    }

    #sidebar .sidebar-header {
        padding: 20px;
        background: #6d7fcc;
    }

    #sidebar ul.components {
        padding: 20px 0;
        border-bottom: 1px solid #47748b;
    }

    #sidebar ul p {
        color: #fff;
        padding: 10px;
    }

    #sidebar ul li a {
        padding: 10px;
        font-size: 1.1em;
        display: block;
    }

    #sidebar ul li a:hover {
        color: #7386D5;
        background: #fff;
    }

    #sidebar ul li.active > a,
    a[aria-expanded="true"] {
        color: #fff;
        background: #6d7fcc;
    }

    a[data-toggle="collapse"] {
        position: relative;
    }

    .dropdown-toggle::after {
        display: block;
        position: absolute;
        top: 50%;
        right: 20px;
        transform: translateY(-50%);
    }

    ul ul a {
        font-size: 0.9em !important;
        padding-left: 30px !important;
        background: #6d7fcc;
    }

    ul.CTAs {
        padding: 20px;
    }

    ul.CTAs a {
        text-align: center;
        font-size: 0.9em !important;
        display: block;
        border-radius: 5px;
        margin-bottom: 5px;
    }

    a.download {
        background: #fff;
        color: #7386D5;
    }

    a.article,
    a.article:hover {
        background: #6d7fcc !important;
        color: #fff !important;
    }

    #content {
        width: 100%;
        padding: 0px;
        min-height: 100vh;
        transition: all 0.3s;
    }

    @media (max-width: 992px) {
        #sidebar {
            margin-left: -300px;
        }
        #sidebar.active {
            margin-left: 0;
        }
        #sidebarCollapse span {
            display: none;
        }
    }

	.left_sidebar {
		width: 300px;
		height: 100%;
        min-height: 100vh;
		background: linear-gradient(180deg, rgba(69,35,121,1) 0%, rgba(69,35,121,1) 370px, rgba(62,168,200,1) 100%);
        transition: .3 ease;
	}
	.left_sidebar_profile {
		width: 100%;
		height: 330px;
		background-image: linear-gradient(rgba(69,35,121,0) 220px, rgba(69,35,121,1)), url(https://portfolio.edus.kz/uploads/images/avatar/default.png);
		background-size: cover;
        background-position: center center;
	}
	.user_name {
		color: #fff;
		text-transform: uppercase;
		text-align: center;
		margin-top: -45px;
	}
	.user_category {
		color: #83e6ff;
		text-align: center;
		/* font-style: italic; */
		font-size: 16px;
        margin-top: 5px;
        margin-bottom: 5px;
	}
	.sidebar_info {
		padding: 20px 20px 0px 20px;
		color: #fff;
	}
	.sidebar_title {
		text-transform: uppercase;
		font-size: 18px;
		font-weight: 600;
		border-bottom: 1px solid #92c9f2;
		padding-bottom: 7px;
		padding-left: 5px;
		padding-right: 5px;
		margin-bottom: 10px;
	}
	.sidebar_info ul {
		list-style: none;
		padding: 0;
		padding-left: 5px !important;
		padding-right: 5px;
		margin-bottom: 25px;
	}
</style>